module.exports = __webpack_public_path__ + "static/img/life-wheel.44d95aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/mytronics/life-wheel.png
// module id = O3u3
// module chunks = 0